import { startTransition, useActionState } from 'react'
import { useMe, useUpdateMeCache } from '../../hooks/useMe'
import { Button, Box, Typography } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'
import { UserAPI } from '../../api/api-switcher'
import { isMobile } from '../../utils/functions'
import { Link, useLocation } from 'react-router'

type Props = {children: React.ReactNode}
const AcceptRules: React.FC<Props> = ({children}) => {
  const me = useMe()
  const updateMeCache = useUpdateMeCache()
  const {t} = useTranslation()
  const location = useLocation()
  const [me_accepted, action, is_pending] = useActionState<boolean, void>(async ()=> {
    await UserAPI.acceptedRules()
    if (me) updateMeCache({accepted_tos_version: me.current_tos_version})
    return true
  }, Boolean(me && me.accepted_tos_version === me.current_tos_version))
  // meがundefined(非ログイン)の場合はtrueにする / meがログインしていてルールを受諾している場合はtrueにする
  const accepted = !me || (me.accepted_tos_version === me.current_tos_version) || me_accepted
  const is_mobile = isMobile()

  return accepted ?
    <>{children}</>
  :
    <Box sx={{
      position: 'fixed',
      top: 0, bottom: 0, left: 0, right: 0,
      backgroundColor: 'background.default',
      //重ねる場合 zIndex: 1600, // tooltips are 1500
    }}>
      {is_mobile && <Box sx={{
        textAlign: 'center', alignContent: 'center', height: '52px'
      }}>
        <Typography
          variant='h2' component='div' fontSize='medium'
          sx={{
            flexGrow: 1,
            fontWeight: 'bold',
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
            textAlign: 'center'
          }}
        >
          {t('accept_rules.mobile_title')}
        </Typography>
      </Box>}
      <Box px={8} sx={{textAlign: 'center', alignContent: 'center', height: 'calc(100% - 52px)'}}>
        <div>
          <span className='material-icons-outlined' style={{fontSize: '48px'}}>
            description
          </span>
          <Typography variant='h3' fontSize={16} fontWeight='bold' my={1}>
            {t('accept_rules.dialog_title')}
          </Typography>
          <Typography fontSize={14} color='text.secondary'>
            <Trans
              i18nKey='accept_rules.dialog_description'
              components={{
                l: <Link
                  key='privacy_policy_link' // key入れないとエラーが出力される
                  to='/about/privacy_policy'
                  state={{from: location.pathname}}
                />
              }}
            />
          </Typography>
          <Button
            color='primary'
            variant='contained'
            disabled={is_pending}
            sx={{my: 2, px: 8}}
            onClick={()=> { startTransition(action) }}
          >
            {t('accept_rules.accept')}
          </Button>
        </div>
      </Box>
    </Box>
}
export default AcceptRules
